
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFog as ObiFogElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fog.js';
 
 
 

 
 export const ObiFog = createComponent({
   react: React,
   tagName: 'obi-fog',
   elementClass: ObiFogElement,
   events: {
     
   }
  });
 
 